<template>
  <div class="p-resolution1">
    <section class="c-p-r about-banner">
      <div class="c-d-f c-fd-c c-ai-c c-ta-c cm-width about-banner-desc">
        <p class="c-fs-38 c-c-text-color c-mb-32 c-fw-b top-title">证券行业运维方案</p>
      </div>
    </section>
    <section class="">
      <section class="c-fs-16 c-m-a case-wrap">
        <div class="c-visible-pc analysis" v-if="$store.state.isPc">
          <div class="cm-width c-d-f c-jc-sb">
            <img src="../../assets/resolution/pic2.png" class="intro-item-img">
            <div class="intro-item-text">
              <div class="c-d-f c-ai-c">
                <img src="../../assets/index/icon.png">
                <p class="c-ml-12 c-fs-24 c-c-text-blue">需求分析</p>
              </div>
              <p class="c-mt-24 c-lh-32 c-ta-j">证券行业的业务系统主要包括：行情发送系统、行情传送系统、行情接收系统、行情客户端系统、交易系统、
                结算系统和开户系统。这些系统需要24小时不间断的管理关于，单纯依靠人力手动运维，已经难以满足市场要求，时间紧张，容易认为出错，后果将难以估计。
              </p>
              <p class="c-lh-32">证券行业系统存在以下几个特点：</p>
              <div class="c-lh-32 c-ta-j">
                <p>1、系统种类多，复杂度很高；</p>
                <p>2、各系统之间关联性很强；</p>
                <p>3、系统的实时性、可用性和稳定性要求极高；</p>
              </div>
            </div>
          </div>
        </div>
        <div class="cm-width c-visible-mobile" v-if="!$store.state.isPc">
          <div class="c-d-f c-ai-c c-mt-24 c-mb-12">
            <img src="../../assets/index/icon.png" class="c-icon-mobile">
            <p class="c-fs-15 c-ml-8 c-c-text-blue">需求分析</p>
          </div>
          <div class="c-mb-12 c-fs-12 c-lh-22">
            <p class="">证券行业的业务系统主要包括：行情发送系统、行情传送系统、行情接收系统、行情客户端系统、交易系统、
              结算系统和开户系统。这些系统需要24小时不间断的管理关于，单纯依靠人力手动运维，已经难以满足市场要求，时间紧张，容易认为出错，后果将难以估计。</p>
            <p>证券行业系统存在以下几个特点：</p>
            <p>1、系统种类多，复杂度很高；</p>
            <p>2、各系统之间关联性很强；</p>
            <p>3、系统的实时性、可用性和稳定性要求极高；</p>
          </div>
          <img src="../../assets/resolution/pic2.png" style="width: 100%;">
        </div>
        <div class="c-bc-white c-visible-pc analysis" v-if="$store.state.isPc">
          <div class="cm-width c-d-f c-jc-sb">
            <div class="intro-item-text">
              <div class="c-d-f c-ai-c c-jc-fe">
                <img src="../../assets/index/icon.png">
                <p class="c-fs-24 c-ml-12 c-c-text-blue">解决方案</p>
              </div>
              <p class="c-mt-24 c-lh-38 c-ta-j">基于证券行业的实际情况与特点，建立基于猫维智能运维管理平台系统的运维管理方案，可以将证券行业的复杂环境下的多种系统的硬件、
                软件、服务、网络指标进行统一采集、存储、分析，实时监控各个业务系统的运行情况，实现异常预警，周期性报表等目标。
              </p>
            </div>
            <img src="../../assets/resolution/pic1.png" class="intro-item-img">
          </div>
        </div>
        <div class="cm-width c-visible-mobile" v-if="!$store.state.isPc">
          <div class="c-d-f c-ai-c c-mt-24 c-mb-12">
            <img src="../../assets/index/icon.png" class="c-icon-mobile">
            <p class="c-fs-15 c-ml-8 c-c-text-blue">解决方案</p>
          </div>
          <p class="c-mb-12 c-fs-12 c-lh-22">基于证券行业的实际情况与特点，建立基于猫维智能运维管理平台系统的运维管理方案，可以将证券行业的复杂环境下的多种系统的硬件、
            软件、服务、网络指标进行统一采集、存储、分析，实时监控各个业务系统的运行情况，实现异常预警，周期性报表等目标。</p>
          <img src="../../assets/resolution/pic1.png" style="width: 100%;">
        </div>

        <div class="cm-width area">
          <div class="">
            <div class="c-d-f c-ai-c c-jc-c section-title">
              <img src="../../assets/index/icon.png" class="icon-m">
              <p class="c-mlr-12 c-c-text-blue">方案优势</p>
              <img src="../../assets/index/icon.png" class="icon-m">
            </div>
            <section class="production card">
              <div class="item">
                <img src="../../assets/resolution/icon/icon7.svg">
                <div>
                  <p class="title">智能运维</p>
                  <p class="desc">智能发现IT相关资产，自动执行巡检指令，自动备份配置文件，智能网络拓扑发现，智能故障预测告警，简化用户日常运维的工作，大大提升运维工作的效率</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon1.svg">
                <div>
                  <p class="title">智能运维大屏</p>
                  <p class="desc">模块化组件式设计，可根据优先级灵活调整布局及展示内容，让您实时了解IT系统的运行状况</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon8.svg">
                <div>
                  <p class="title">统一管理</p>
                  <p class="desc">支持IT资产覆盖硬件设备、服务器、线路、WEB资产、虚拟化、混合云、存储、应用、中间件、数据库等，集团化分权分级管理，实现IT资产统一运维管理需求</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon10.svg">
                <div>
                  <p class="title">大数据分析</p>
                  <p class="desc">千万数据量级的数据分析能力，为IT运行的各项指标提供报表输出，为未来的IT投资提供可靠且有效的参考数据</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon9.svg">
                <div>
                  <p class="title">高性能</p>
                  <p class="desc">支持集群及分布式部署架构，可支撑百万级IT资产集中监控</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon2.svg">
                <div>
                  <p class="title">强大的分权分级管理</p>
                  <p class="desc">可灵活定制用户的机构、部门及用户，通过角色定义用户的功能操作权限和数据权限，实现复杂的多级机构的分权分级的IT资产管理</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon3.svg">
                <div>
                  <p class="title">统一预警中心</p>
                  <p class="desc">针对监控的资产产生的预警，统一预警中心进行分级别统一管理展示，可以快速定位预警问题的，针对问题也可以提供历史的解决方案</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon4.svg">
                <div>
                  <p class="title">符合等级保护2.0标准（三级）要求</p>
                  <p class="desc">产品严格按照等级保护2.0（三级）标准要求进行设计研发，避免IT环境的安全短板</p>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="c-bc-white area">
          <div class="cm-width">
            <div class="c-d-f c-ai-c c-jc-c section-title">
              <img src="../../assets/index/icon.png" class="icon-m">
              <p class="c-mlr-12 c-c-text-blue">用户价值</p>
              <img src="../../assets/index/icon.png" class="icon-m">
            </div>
            <section class="fast card">
              <div class="item">
                <img src="../../assets/resolution/icon/icon12.png">
                <div>
                  <p class="title">增强配置科学化管理</p>
                  <p class="desc">通过设备配置管理平台，实现配置定时备份、配置对比、批量设备配置上传、IOS批量下载/上传、配置变更管理等科学化管理手段</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon14.png">
                <div>
                  <p class="title">提高关键业务的生产力</p>
                  <p class="desc">猫维网络性能监控解决方案可以实时监控网络应用的性能，提供关于网络应用的各种统计报告。根据这些报告，通过消除不必要的网络流量，减轻高峰时段网络流量（将时限要求不高的应用转至非高峰时段运行）等措施提高关键业务应用的运行效率</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon16.png">
                <div>
                  <p class="title">减轻管理员的工作负担</p>
                  <p class="desc">通过自动对各种服务器,服务,进程的监控,使管理员不必每天24 小时的对其进行手动的检查,节省管理员时间</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon15.png">
                <div>
                  <p class="title">增强网络安全</p>
                  <p class="desc">通过对网络流量的实时监控和历史分析，识别安全攻击或蠕虫病毒威胁等异常活动，阻塞安全漏洞</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon13.png">
                <div>
                  <p class="title">证券行业复杂业务系统深度监控</p>
                  <p class="desc">通过使用WMI、SNMP、ODBC、SSH、TELNET、HTTP、SCRIPT、API等多种协议周期轮询被监控服务器或应用系统以获取操Windows/linux操作系统、应用程序性能数据</p>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/resolution/icon/icon17.png">
                <div>
                  <p class="title">有效的保证最大化服务正常运行时间</p>
                  <p class="desc">通过各种及时有效的通信手段,使管理员在有任何网络和服务障出现的同时,了解到该信息并且进行有效的处理</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>

export default {
  name: 'resolution',
  data () {
    return {

    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss">
.p-resolution1 {
  min-height: calc(100vh - 90px - 525px);
  .about-banner {
    height: 560px;
    background: url("../../assets/resolution/resolution-banner2.jpg") no-repeat;
    background-size: cover;
    background-position: top;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    .about-banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .pic {
    height: 417px;
  }
  .pic-mobile {
    width: 100%;
  }
  .analysis {
    padding: 80px;
    .intro-item-text {
      width: 46%;
    }
    .intro-item-img {
      width: 48%;
      height: 360px;
      object-fit: cover;
    }
  }
  .area {
    padding-bottom: 30px;
    padding-top: 50px;
    @media screen and (max-width: $max-width-standard) {
      padding-bottom: 24px;
      padding-top: 40px;
    }
    .section-title {
      font-size: 24px;
      color: $text-blue;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
      @media screen and (max-width: $max-width-standard) {
        font-size: 19px;
        margin-top: 0px;
        margin-bottom: 0px;
        .icon-m {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1180px;
    margin-left: auto;
    margin-right: auto;
    &.production {
      .item {
        width: 90%;
        @media (min-width: $min-width-standard) {
          &.item {
            width: 45%;
          }
        }
      }
    }
    &.advantage {
      .item {
        width: 90%;
        @media (min-width: $min-width-standard) {
          &.item {
            width: 30%;
          }
        }
      }
    }
    &.fast {
      .item {
        width: 90%;
        flex-direction: column;
        align-items: center;
        text-align: center;
        img {
          margin-right: 0;
          margin-bottom: 20px;
        }
        @media (min-width: $min-width-standard) {
          &.item {
            width: 30%;
          }
        }
      }
    }
    .item {
      display: flex;
      padding: 30px 15px;
      @media screen and (max-width: $max-width-standard) {
        padding: 15px 15px;
      }
      margin: 10px auto;
      // &:hover {
      //   background: #fff;
      //   box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
      // }
      @media (min-width: $min-width-standard) {
        &.item {
          margin: 10px 0;
        }
      }
      img {
        display: block;
        flex-shrink: 0;
        width: 80px;
        height: 80px;
        object-fit: contain;
        margin-right: 15px;
      }
      .title {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 15px;
        @media screen and (max-width: $max-width-standard) {
          font-size: 15px;
          margin-bottom: 8px;
        }
      }
      .desc {
        color: $text-grey;
        line-height: 22px;
        font-size: 14px;
        margin-bottom: 0;
        @media screen and (max-width: $max-width-standard) {
          font-size: 12px;
        }
      }
    }
  }
  // .case-card {
  //   .case-item {
  //     position: relative;
  //     cursor: pointer;
  //     border-radius: 1px;
  //     box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
  //     transition: all 0.3s ease-in-out;
  //     &::before {
  //       content: "";
  //       width: 0;
  //       height: 4px;
  //       background: $orange;
  //       position: absolute;
  //       top: 0;
  //       left: 50%;
  //       transition: all 0.3s;
  //     }
  //     &:hover {
  //       transform: translateY(-16px);
  //     }
  //     &:hover::before {
  //       left: 0;
  //       width: 100%;
  //     }
  //     .case-img {
  //       height: 126px;
  //       background: url('../../../assets/resolution/icon/logo-plus.png');
  //       background-size: cover;
  //     }
  //   }
  // }
  // .case-card-mobile {
  //   .case-wrap-mobile {
  //     width: 680px;
  //     .case-item {
  //       position: relative;
  //       border-radius: 1px;
  //       box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
  //       .case-img {
  //         height: 63px;
  //         background: url('../../../assets/resolution/icon/logo-plus.png');
  //         background-size: cover;
  //       }
  //     }
  //   }
  // }
}
</style>
